import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { apiClient } from '@/lib/api/client'

export function useVendors() {
  return useQuery({
    queryKey: ['vendors'] as const,
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/api/vendors/', {})
      if (error) throw new Error('Failed to load vendors')
      return data ?? []
    },
    staleTime: 60_000,
  })
}

// Suppliers aren't a first-class entity in the schema; they live as a column
// on vendor_rules. Same derivation SupplierCombobox uses for the PO wizard's
// picklist — de-duplicate the supplier strings across all vendor records.
export function useSuppliers(): string[] {
  const { data: vendors = [] } = useVendors()
  return useMemo(() => {
    const set = new Set<string>()
    for (const v of vendors) {
      const s = (v.supplier ?? '').trim()
      if (s) set.add(s)
    }
    return Array.from(set).sort((a, b) => a.localeCompare(b))
  }, [vendors])
}
